import { Navigate } from 'react-router'

import { useSesion } from '../auth'
import { destinoTrasLogin } from '../lib/raiz-por-rol'
import { useVerComo } from '../ver-como'
import { DashboardAdmin } from './dashboard-admin'

/** Portada `/`: admin ve operación; cliente redirige a su nivel 2 (FR-005). */
export function RaizPorRol() {
    const { data: sesion, isPending } = useSesion()
    const { vista } = useVerComo()
    if (isPending || !sesion) return null
    if (sesion.role === 'cliente') {
        const dest = destinoTrasLogin(sesion) ?? '/sin-negocio'
        return <Navigate to={dest} replace />
    }
    if (vista) return <Navigate to={`/business/${vista.accountId}`} replace />
    return <DashboardAdmin />
}
